import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Header from '../../components/GlobalComponents/Header/Header';
import Footer from '../../components/GlobalComponents/Footer/Footer';
import Banner from "../../components/HomePage/Banner/Banner";
import UnderBanner from "../../components/HomePage/UnderBanner/UnderBanner";
import PlatformGlance from "../../components/HomePage/PlatformGlance/PlatformGlance";
import BestFor from "../../components/HomePage/BestFor/BestFor";
import ForYou from "../../components/HomePage/ForYou/ForYou";
import Advantages from "../../components/HomePage/Advantages/Advantages";
import SeeWhy from "../../components/HomePage/SeeWhy/SeeWhy";
import FastConv from "../../components/HomePage/FastConv/FastConv";
import DepWith from "../../components/HomePage/DepWith/DepWith";

const HomePage = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <title>IR Strategies</title>
                <meta name="title" content="IR Strategies - Your Gateway to Financial Markets" />
                <meta property="og:title" content="IR Strategies - Your Gateway to Financial Markets" />
                <meta property="twitter:title" content="IR Strategies - Your Gateway to Financial Markets" />
                
                <meta name="description" content="IR Strategies offers a user-friendly platform for trading stocks, options, futures, and forex. Join our community of traders and start trading today!"/>
                <meta property="og:description" content="IR Strategies offers a user-friendly platform for trading stocks, options, futures, and forex. Join our community of traders and start trading today!"/>
                <meta property="twitter:description" content="IR Strategies offers a user-friendly platform for trading stocks, options, futures, and forex. Join our community of traders and start trading today!" />

                <meta property="og:image" content="preview.png" />
                <meta property="og:type" content="website" />
                <meta property="twitter:image" content="preview.png" />
                <meta property="twitter:card" content="summary_large_image" />
            </Helmet>
            <div className="ovf-hidden">
                <Header />
                <Banner />
                <UnderBanner />
                <PlatformGlance />
                <ForYou />
                <BestFor />
                <Advantages />
                {/* <SeeWhy /> */}
                <DepWith />
                <FastConv />
                <Footer />
            </div>
        </HelmetProvider>
    );
};

export default HomePage;
